import React, { Component } from "react";

import DynamicTable from "@atlaskit/dynamic-table";

import "./myTable.css";
export default class MyTable extends Component {
  render() {
    return (
      <div className="my__table">
        <DynamicTable
          caption={
            <span className="my__table-caption">{this.props.caption}</span>
          }
          head={this.props.head}
          rows={this.props.rows}
          emptyView={
            <div className="my__table-emptyView">{this.props.emptyView}</div>
          }
          rowsPerPage={this.props.rowsPerPage || 10}
          defaultPage={this.props.defaultPage || 1}
          loadingSpinnerSize={this.props.loadingSpinnerSize || "large"}
          isLoading={this.props.loading}
          isFixedSize={this.props.isFixedSize || true}
          defaultSortKey={this.props.defaultSortKey || "date"}
          defaultSortOrder={this.props.defaultSortOrder || "ASC"}
          onSort={this.props.onSort}
          onSetPage={this.props.onSetPage}
          page={this.props.page || 1}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/myTable/MyTable.js